module.exports = __webpack_public_path__ + "static/media/doAdmin.300d49da.png";